export const doctorJob = { id: 1, label: 'Médecin' };
